export const DAILY_CHECK_IN_MEMBER_PROGRESS = "DAILY_CHECK_IN_MEMBER_PROGRESS";
export const DAILY_CHECK_IN_CHECK_IN = "DAILY_CHECK_IN_CHECK_IN";
export const DAILY_CHECK_IN_CLEAR_PROGRESS = "DAILY_CHECK_IN_CLEAR_PROGRESS";
export const DAILY_CHECK_IN_GET_VIP_LEVEL_REQUIREMENT_AND_REWARD = "DAILY_CHECK_IN_GET_VIP_LEVEL_REQUIREMENT_AND_REWARD";
export const DAILY_CHECK_IN_SIMULATE_CHECK_IN = "DAILY_CHECK_IN_SIMULATE_CHECK_IN";